export function setQuizEntrant(elem) {
    if (!elem) return;

    // Clear localstorage before commencing new quiz
    ['quizUserId', 'quizResults'].forEach(key => {
        localStorage.removeItem(key);
    });

    // Now generate a new userId
    const userId = generateCustomUserId();
    const API_ENDPOINT = `/umbraco/api/quiztrackerapi/addentry?uniqueId=${userId}`;

    function generateCustomUserId() {
        let userId = localStorage.getItem("quizUserId");

        if (!userId) {
            userId = "user_" + Math.random().toString(36).substring(2, 10);
            localStorage.setItem("quizUserId", userId);
        }

        return userId;
    }

    fetch(API_ENDPOINT, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ userId }),
    })
        .then(async (res) => {
            if (!res.ok) {
                throw new Error(`Server error: ${res.status}`);
            }

            const contentType = res.headers.get("content-type");

            if (contentType && contentType.includes("application/json")) {
                return res.json();
            } else {
                return res.text(); // fallback if not JSON
            }
        })
        .then((data) => {
            console.log("Tracking successful:", data);
        })
        .catch((error) => {
            console.error("Error tracking quiz start:", error);
        });
}
